var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from "react";
import { StepType } from "@types";
import { findSourceById, getSelectedStepDetailsById, validateFieldConfiguration, registerStep, validateSource, validateStep, validateStepNameAndId, handleStepFieldValueChanges, handleMultipleStepFieldValueChanges } from "@utils";
import { FormSection } from "@components/FormSection/FormSection";
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput";
import { FilterConditionsEditor } from "../FilterConditions/FilterConditionsEditor";
import { getFilterConditionsFromQuery, getQueryFromFilterConditions, validateFilterConditions } from "../FilterConditions/filter-condition-utils";
import Icon from '@images/filter.svg';
import { Checkbox } from "uxp/components";
import { checkStatus } from "@query-engine-service";
import '../FilterConditions/FilterConditionsEditor.scss';
export function renderStep(context, query, onChange, selectedStepId) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId);
    const _step = Object.assign({}, step);
    const $L = (key) => context.uxpContext.$L(key);
    const [errors, setErrors] = useState({});
    const [counter, setCounter] = useState(0);
    const [supportParams, setSupportParams] = useState(false);
    const hasModifiedRef = useRef(false);
    const modifiedConditionsRef = useRef(null);
    useEffect(() => {
        checkStatus(context).then(res => {
            var _a;
            setSupportParams(((_a = res === null || res === void 0 ? void 0 : res.details) === null || _a === void 0 ? void 0 : _a.supportParams) || false);
        });
    }, []);
    useEffect(() => {
        const { isValid, errors } = validateStep(query, step);
        if (hasModifiedRef.current) {
            errors.filter = 'lqe.step.filter.unsaved-changes';
        }
        const resolved = Object.fromEntries(Object.entries(errors || {}).map(([k, v]) => [k, v && v.startsWith('lqe.') ? $L(v) : v]));
        setErrors(resolved);
    }, [step, counter]);
    function onValueChange(field, value, source) {
        return __awaiter(this, void 0, void 0, function* () {
            const _query = yield handleStepFieldValueChanges(context, query, selectedStepId, field, value, source);
            onChange(_query);
        });
    }
    function applyFilterConditionChanges(conditions) {
        return __awaiter(this, void 0, void 0, function* () {
            const _query = yield handleMultipleStepFieldValueChanges(context, query, selectedStepId, [{
                    field: 'filter',
                    value: getQueryFromFilterConditions(conditions)
                }, {
                    field: 'ui',
                    value: conditions
                }]);
            onChange(_query);
            hasModifiedRef.current = false;
            modifiedConditionsRef.current = null;
        });
    }
    function getFilterConditions() {
        if (modifiedConditionsRef.current)
            return modifiedConditionsRef.current;
        if (!!(_step === null || _step === void 0 ? void 0 : _step.ui))
            return _step.ui;
        return getFilterConditionsFromQuery(_step === null || _step === void 0 ? void 0 : _step.filter);
    }
    const source = findSourceById(query, _step === null || _step === void 0 ? void 0 : _step.source);
    return React.createElement(React.Fragment, null,
        React.createElement(FormSection, { label: $L('lqe.step.filter.source'), error: errors === null || errors === void 0 ? void 0 : errors.source },
            React.createElement(SourceSelectorInput, { source: source, onChange: newSource => {
                    onValueChange('source', newSource, true);
                }, availableSources: [...previousSteps, ...selectedSources], query: query })),
        React.createElement(FormSection, { label: $L('lqe.step.filter.filters'), error: errors === null || errors === void 0 ? void 0 : errors.filter },
            React.createElement("div", { className: "lqe-filter-body-6f311ea4" },
                supportParams && React.createElement(Checkbox, { checked: _step.ignoreFiltersIfValueIsEmpty || false, onChange: v => {
                        onValueChange('ignoreFiltersIfValueIsEmpty', v);
                    }, label: $L('lqe.step.filter.ignore-empty'), type: "bordered" }),
                React.createElement(FilterConditionsEditor, { filterConditions: getFilterConditions(), onChange: updated => {
                        applyFilterConditionChanges(updated);
                    }, attributes: (source === null || source === void 0 ? void 0 : source.schema) || [], onChnageConfitions: conds => {
                        const reRender = hasModifiedRef.current == false;
                        hasModifiedRef.current = true;
                        modifiedConditionsRef.current = conds;
                        if (reRender)
                            setCounter(prev => prev + 1);
                    }, query: query }))));
}
function validate(query, step) {
    const errors = validateStepNameAndId(step);
    // validate source
    const source = validateSource(query, step, 'source');
    if (!source.isValid)
        errors.source = source.error;
    // validate filters 
    const filters = validateFilterConditions(step === null || step === void 0 ? void 0 : step.filter);
    if (filters.isValid) {
        // check if the configured fields are form the correct source
        const fields = validateFieldConfiguration(query, step, filters.uniqueAttributes, 'source');
        if (!fields.isValid)
            errors.filter = fields.error;
    }
    else
        errors.filter = filters.error;
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
}
registerStep({
    type: StepType.Filter,
    name: "lqe.step.filter.name",
    description: "lqe.step.filter.description",
    icon: Icon,
    iconStyles: {
        backgroundSize: '50%'
    },
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return Object.assign(Object.assign({}, basicProps), { source: previousSource, filter: {} });
    }
});
